export default {
  'global.action.view': '查看',
  'global.action.download': '下载',
  'global.action.cash': '提现',
  'global.action.cashusdt': '回U',
  'global.action.logs': '日志',
  'global.message.success': '操作成功',
  'global.message.error': '操作错误',
};